import './productRoadmap.scss';

function ProductRoadmap() {
  return (
    <div className="productRoadmap">
      <div className="roadmapLeft">
        <div className="roadmapHousing">
          <div className="title">Product Roadmap</div>
          <p>
            We are looking at a series of 5 currently. We do not have the timeline of the next two artwork but it will be within this year. The first two will
            be sold in opensea while the rest will be minted via this website.
          </p>
          <p>
            What we are looking at goes beyond the digital space. We want to put digital art on the same pedestal as classical art in the physical world. We are
            looking to integrate it as a fixed panel installation for your home.
          </p>
          <p>
            Strange Odyssey NFT holders will be given the options to have it printed and framed or have it displayed in a high res digital screen. We will
            further announce the details in Q4 of this year.
          </p>
        </div>
        <div className="roadmapHousing roadmapImage3"></div>
      </div>
      <div className="roadmapRight">
        <div className="roadmapHousing roadmapImage1"></div>
        <div className="roadmapHousing roadmapImage2"></div>
      </div>
    </div>
  );
}

export default ProductRoadmap;
